import React from "react";

const IconCommute = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1284_8161)">
      <path
        d="M10.1825 10.3517C11.8237 10.3517 13.1541 9.02122 13.1541 7.38005C13.1541 5.73888 11.8237 4.40845 10.1825 4.40845C8.54137 4.40845 7.21094 5.73888 7.21094 7.38005C7.21094 9.02122 8.54137 10.3517 10.1825 10.3517Z"
        fill="url(#paint0_linear_1284_8161)"
      />
      <path
        d="M10.1832 9.86003C11.5529 9.86003 12.6633 8.74967 12.6633 7.37997C12.6633 6.01027 11.5529 4.8999 10.1832 4.8999C8.81349 4.8999 7.70312 6.01027 7.70312 7.37997C7.70312 8.74967 8.81349 9.86003 10.1832 9.86003Z"
        fill="url(#paint1_linear_1284_8161)"
      />
      <path
        d="M11.5109 4.72168C11.7114 5.12168 11.8244 5.57313 11.8244 6.051C11.8244 7.69216 10.4939 9.02261 8.85275 9.02261C8.37489 9.02261 7.92344 8.90966 7.52344 8.70919C8.01134 9.68294 9.01834 10.3515 10.1817 10.3515C11.8229 10.3515 13.1533 9.0211 13.1533 7.37994C13.1533 6.21658 12.4847 5.20952 11.5109 4.72168Z"
        fill="url(#paint2_linear_1284_8161)"
      />
      <path
        d="M21.5938 19.6894V9.28418H31.3992C31.7304 9.28418 31.9989 9.55267 31.9989 9.8839V19.0896C31.9989 19.4208 31.7304 19.6893 31.3992 19.6893H21.5938V19.6894Z"
        fill="url(#paint3_linear_1284_8161)"
      />
      <path
        d="M21.5938 18.3246V10.6489H31.9989V18.3246H21.5938Z"
        fill="url(#paint4_linear_1284_8161)"
      />
      <path
        d="M29.5973 15.2697H28.658C28.2256 15.2697 27.8751 14.9192 27.8751 14.4869C27.8751 14.0546 28.2256 13.7041 28.658 13.7041H29.5973C30.0296 13.7041 30.3801 14.0546 30.3801 14.4869C30.3801 14.9192 30.0296 15.2697 29.5973 15.2697ZM25.5268 15.2697H24.5875C24.1552 15.2697 23.8047 14.9192 23.8047 14.4869C23.8047 14.0546 24.1552 13.7041 24.5875 13.7041H25.5268C25.9592 13.7041 26.3097 14.0546 26.3097 14.4869C26.3097 14.9192 25.9592 15.2697 25.5268 15.2697Z"
        fill="url(#paint5_linear_1284_8161)"
      />
      <path
        d="M31.9989 18.5998L22.6834 9.28431L22.6829 9.28418H21.5938V19.6893H31.3992C31.7305 19.6893 31.999 19.4209 31.999 19.0896V18.5998H31.9989Z"
        fill="url(#paint6_linear_1284_8161)"
      />
      <path
        d="M22.0848 0.03125H12.879C12.5478 0.03125 12.2793 0.299736 12.2793 0.630968V9.28433H11.3421C5.07802 9.28433 0 14.3624 0 20.6265C0 26.8905 5.07802 31.9686 11.3421 31.9686C17.6062 31.9686 22.6842 26.8905 22.6842 20.6265V19.6896H22.6844V0.630968C22.6845 0.299736 22.4159 0.03125 22.0848 0.03125ZM12.3447 20.6265C12.3447 21.1438 11.9253 21.5633 11.4079 21.5633H11.4072C10.8899 21.5633 10.4704 21.1438 10.4704 20.6265C10.4704 20.1091 10.8899 19.6896 11.4072 19.6896H12.2793H12.3447V20.6265Z"
        fill="url(#paint7_linear_1284_8161)"
      />
      <path
        d="M13.5329 0.03125L13.5987 20.6265C13.5987 21.8338 12.6168 22.8158 11.4088 22.8158C10.2014 22.8158 9.21946 21.8339 9.21946 20.6265C9.21946 19.4191 10.2014 18.4371 11.4088 18.4371H12.2805V10.5368H11.3436C5.78027 10.5368 1.25391 15.0632 1.25391 20.6265C1.25391 26.1899 5.78028 30.7162 11.3437 30.7162C16.9071 30.7162 21.4334 26.1899 21.4334 20.6265V0.03125H13.5329Z"
        fill="url(#paint8_linear_1284_8161)"
      />
      <path
        d="M0.0390625 19.6897H11.4076H12.2796V9.28442H11.3425C5.39386 9.28442 0.515423 13.864 0.0390625 19.6897Z"
        fill="url(#paint9_linear_1284_8161)"
      />
      <path
        d="M11.2658 27.8186C10.8497 27.8186 10.5034 27.491 10.4845 27.0711C10.4649 26.6392 10.7993 26.2733 11.2311 26.2538C11.5067 26.2414 11.7827 26.2091 12.0515 26.1578C12.4764 26.0766 12.8861 26.3554 12.9671 26.78C13.0481 27.2047 12.7696 27.6146 12.3449 27.6956C12.0028 27.7608 11.6518 27.802 11.3016 27.8177C11.2897 27.8183 11.2777 27.8186 11.2658 27.8186ZM8.22331 27.2235C8.11306 27.2235 8.00113 27.2001 7.89459 27.1507C7.57741 27.0037 7.26827 26.8321 6.9755 26.6408C6.61365 26.4042 6.51206 25.9191 6.74861 25.5572C6.9851 25.1954 7.47024 25.0937 7.83216 25.3303C8.06174 25.4804 8.30425 25.615 8.55297 25.7303C8.94519 25.9121 9.11579 26.3775 8.93396 26.7696C8.80157 27.0554 8.51865 27.2235 8.22331 27.2235ZM15.0167 26.4173C14.7863 26.4173 14.558 26.3161 14.4034 26.1217C14.1344 25.7833 14.1906 25.2909 14.529 25.0219C14.744 24.851 14.9481 24.6629 15.1357 24.4631C15.4315 24.148 15.9269 24.132 16.2422 24.4281C16.5574 24.7239 16.5731 25.2193 16.2772 25.5345C16.0378 25.7895 15.7775 26.0293 15.5033 26.2474C15.3593 26.3617 15.1874 26.4173 15.0167 26.4173ZM5.29443 24.4983C5.01816 24.4983 4.75049 24.3519 4.60794 24.0928C4.43808 23.7842 4.29063 23.4608 4.16954 23.1318C4.02026 22.726 4.2282 22.2761 4.63391 22.1269C5.03962 21.9777 5.4895 22.1855 5.63884 22.5913C5.73283 22.8468 5.84746 23.098 5.97954 23.3379C6.18798 23.7167 6.04994 24.1927 5.67121 24.4011C5.55143 24.467 5.42199 24.4983 5.29443 24.4983ZM17.2096 23.0723C17.1441 23.0723 17.0776 23.064 17.0113 23.0468C16.5929 22.9375 16.3424 22.5099 16.4516 22.0916C16.5205 21.8281 16.5696 21.557 16.5977 21.2857C16.6423 20.8556 17.0273 20.5438 17.4571 20.5877C17.8871 20.6324 18.1995 21.017 18.155 21.4471C18.1186 21.7972 18.0552 22.1471 17.9664 22.4872C17.8744 22.8391 17.5571 23.0723 17.2096 23.0723ZM4.59639 20.5622C4.55699 20.5622 4.51714 20.5592 4.47699 20.5531C4.04963 20.4877 3.75623 20.0883 3.82161 19.6609C3.87482 19.3133 3.9552 18.9668 4.06042 18.6312C4.18974 18.2187 4.62895 17.9891 5.04157 18.1186C5.45405 18.2479 5.68357 18.6872 5.55419 19.0997C5.47269 19.3598 5.41044 19.6282 5.36922 19.8977C5.30993 20.2849 4.97644 20.5622 4.59639 20.5622ZM17.4096 19.0194C16.9773 19.0194 16.6268 18.6689 16.6268 18.2366V17.2973C16.6268 16.865 16.9773 16.5145 17.4096 16.5145C17.8419 16.5145 18.1924 16.865 18.1924 17.2973V18.2366C18.1924 18.6689 17.8419 19.0194 17.4096 19.0194ZM6.43739 17.0131C6.23322 17.0131 6.02924 16.9337 5.87576 16.7756C5.57459 16.4655 5.58186 15.9699 5.89201 15.6687C6.14293 15.4251 6.41418 15.1975 6.69816 14.9924C7.04885 14.7395 7.53801 14.8185 7.79106 15.1689C8.04411 15.5194 7.96511 16.0087 7.61462 16.2618C7.39194 16.4225 7.17929 16.6009 6.98265 16.7919C6.83055 16.9396 6.63391 17.0131 6.43739 17.0131ZM10.0301 15.2496C9.64693 15.2496 9.31212 14.968 9.25615 14.5777C9.19485 14.1498 9.49208 13.7532 9.92 13.6918C10.2645 13.6424 10.6167 13.6175 10.9669 13.6175C11.3992 13.6175 11.7497 13.9679 11.7497 14.4003C11.7497 14.8326 11.3992 15.1831 10.9669 15.1831C10.6908 15.1831 10.4132 15.2028 10.1421 15.2417C10.1044 15.2469 10.0669 15.2496 10.0301 15.2496ZM17.4096 14.949C16.9773 14.949 16.6268 14.5985 16.6268 14.1662V13.2268C16.6268 12.7945 16.9773 12.444 17.4096 12.444C17.8419 12.444 18.1924 12.7945 18.1924 13.2268V14.1662C18.1924 14.5985 17.8419 14.949 17.4096 14.949ZM17.4096 10.8785C16.9773 10.8785 16.6268 10.528 16.6268 10.0957V9.15634C16.6268 8.72402 16.9773 8.37353 17.4096 8.37353C17.8419 8.37353 18.1924 8.72402 18.1924 9.15634V10.0957C18.1924 10.528 17.8419 10.8785 17.4096 10.8785ZM17.4096 6.80804C16.9773 6.80804 16.6268 6.45754 16.6268 6.02523V5.08594C16.6268 4.65362 16.9773 4.30313 17.4096 4.30313C17.8419 4.30313 18.1924 4.65362 18.1924 5.08594V6.02529C18.1924 6.45754 17.8419 6.80804 17.4096 6.80804ZM17.4096 2.73758C16.9773 2.73758 16.6268 2.38708 16.6268 1.95477V1.01547C16.6268 0.58316 16.9773 0.232666 17.4096 0.232666C17.8419 0.232666 18.1924 0.58316 18.1924 1.01547V1.95483C18.1924 2.38714 17.8419 2.73758 17.4096 2.73758Z"
        fill="url(#paint10_linear_1284_8161)"
      />
      <path
        d="M24.6662 25.116C26.5528 25.116 28.0823 23.5865 28.0823 21.6998C28.0823 19.8132 26.5528 18.2837 24.6662 18.2837C22.7795 18.2837 21.25 19.8132 21.25 21.6998C21.25 23.5865 22.7795 25.116 24.6662 25.116Z"
        fill="url(#paint11_linear_1284_8161)"
      />
      <path
        d="M24.6675 24.5508C26.2421 24.5508 27.5186 23.2743 27.5186 21.6997C27.5186 20.1251 26.2421 18.8486 24.6675 18.8486C23.0929 18.8486 21.8164 20.1251 21.8164 21.6997C21.8164 23.2743 23.0929 24.5508 24.6675 24.5508Z"
        fill="url(#paint12_linear_1284_8161)"
      />
      <path
        d="M26.1973 18.644C26.4277 19.1039 26.5576 19.6228 26.5576 20.1722C26.5576 22.0589 25.0281 23.5884 23.1414 23.5884C22.5921 23.5884 22.0731 23.4585 21.6133 23.2281C22.1742 24.3475 23.3318 25.1161 24.6692 25.1161C26.5558 25.1161 28.0853 23.5866 28.0853 21.6999C28.0853 20.3626 27.3167 19.2049 26.1973 18.644Z"
        fill="url(#paint13_linear_1284_8161)"
      />
      <path
        d="M27.9676 24.1835C29.2399 24.1835 30.2712 23.1522 30.2712 21.88C30.2712 20.6078 29.2399 19.5764 27.9676 19.5764C26.6954 19.5764 25.6641 20.6078 25.6641 21.88C25.6641 23.1522 26.6954 24.1835 27.9676 24.1835Z"
        fill="url(#paint14_linear_1284_8161)"
      />
      <path
        d="M27.9655 23.8025C29.0272 23.8025 29.888 22.9418 29.888 21.88C29.888 20.8183 29.0272 19.9575 27.9655 19.9575C26.9037 19.9575 26.043 20.8183 26.043 21.88C26.043 22.9418 26.9037 23.8025 27.9655 23.8025Z"
        fill="url(#paint15_linear_1284_8161)"
      />
      <path
        d="M28.9973 19.8193C29.1527 20.1294 29.2403 20.4794 29.2403 20.8498C29.2403 22.122 28.2089 23.1534 26.9367 23.1534C26.5663 23.1534 26.2163 23.0658 25.9062 22.9104C26.2845 23.6652 27.0651 24.1835 27.9669 24.1835C29.2391 24.1835 30.2704 23.1522 30.2704 21.8799C30.2704 20.9782 29.7521 20.1976 28.9973 19.8193Z"
        fill="url(#paint16_linear_1284_8161)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1284_8161"
        x1="9.0707"
        y1="6.26821"
        x2="12.9194"
        y2="10.1169"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#92F37F" />
        <stop offset="1" stopColor="#4AB272" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1284_8161"
        x1="10.4792"
        y1="7.676"
        x2="7.78996"
        y2="4.9868"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#92F37F" stopOpacity="0" />
        <stop offset="1" stopColor="#FFEE83" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1284_8161"
        x1="10.2848"
        y1="8.51876"
        x2="14.3695"
        y2="0.921903"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4AB272" stopOpacity="0" />
        <stop offset="1" stopColor="#009245" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1284_8161"
        x1="28.1789"
        y1="14.4868"
        x2="21.5363"
        y2="14.4868"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BEC3D2" />
        <stop offset="0.97" stopColor="#808797" />
        <stop offset="1" stopColor="#7E8595" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1284_8161"
        x1="28.993"
        y1="14.4868"
        x2="20.8483"
        y2="14.4868"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7E8595" />
        <stop offset="1" stopColor="#555A66" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1284_8161"
        x1="23.8048"
        y1="14.4869"
        x2="30.3801"
        y2="14.4869"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9F7FC" />
        <stop offset="1" stopColor="#F0DDFC" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1284_8161"
        x1="28.4709"
        y1="18.4029"
        x2="15.9794"
        y2="10.6779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#555A66" stopOpacity="0" />
        <stop offset="1" stopColor="#555A66" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1284_8161"
        x1="9.04496"
        y1="10.5563"
        x2="27.2815"
        y2="28.7929"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BEC3D2" />
        <stop offset="0.97" stopColor="#808797" />
        <stop offset="1" stopColor="#7E8595" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1284_8161"
        x1="6.6705"
        y1="7.64725"
        x2="26.9601"
        y2="28.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7E8595" />
        <stop offset="1" stopColor="#555A66" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1284_8161"
        x1="7.61302"
        y1="16.096"
        x2="17.4656"
        y2="9.91726"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#555A66" stopOpacity="0" />
        <stop offset="1" stopColor="#555A66" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1284_8161"
        x1="3.81252"
        y1="14.0256"
        x2="18.1924"
        y2="14.0256"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9F7FC" />
        <stop offset="1" stopColor="#F0DDFC" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1284_8161"
        x1="23.388"
        y1="20.4217"
        x2="27.8124"
        y2="24.8461"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#92F37F" />
        <stop offset="1" stopColor="#4AB272" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1284_8161"
        x1="25.0078"
        y1="22.04"
        x2="21.9163"
        y2="18.9486"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#92F37F" stopOpacity="0" />
        <stop offset="1" stopColor="#FFEE83" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1284_8161"
        x1="24.7878"
        y1="23.0091"
        x2="29.4835"
        y2="14.2759"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4AB272" stopOpacity="0" />
        <stop offset="1" stopColor="#009245" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1284_8161"
        x1="27.1058"
        y1="21.0181"
        x2="30.0892"
        y2="24.0016"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#92F37F" />
        <stop offset="1" stopColor="#4AB272" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1284_8161"
        x1="28.1949"
        y1="22.1095"
        x2="26.1103"
        y2="20.0249"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#92F37F" stopOpacity="0" />
        <stop offset="1" stopColor="#FFEE83" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1284_8161"
        x1="28.0469"
        y1="22.7628"
        x2="31.2132"
        y2="16.8738"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4AB272" stopOpacity="0" />
        <stop offset="1" stopColor="#009245" />
      </linearGradient>
      <clipPath id="clip0_1284_8161">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IconCommute;
